/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CommunicationsHorizontalNavEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const communicationsHorizontalNavEntrypoint: EntryPoint<
	CommunicationsHorizontalNavEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsHorizontalNavEntrypointComponent>(
		/* webpackChunkName: "async-communications-horizontal-nav-entrypoint" */ './ui/HorizontalCommunicationsNav.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
